export default __webpack_public_path__ + "static/Types-Of-People-Youll-Meet-On-A-Plane-Baby-b3ce5909fa8db5b5f1f0becfb0407e82.jpg";